import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import LandingPromo from 'pages/marketing/LandingPromo';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/promo/:slug',
      element: <LandingPromo />
    },
    MainRoutes,
    LoginRoutes
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
